import styled from 'styled-components';

import { Text } from '~/components/ui/Text';
import descBg from '../../assets/images/desc_bg.svg';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 144px;
`;

const StyledHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	user-select: none;
	pointer-events: none;

	img {
		opacity: 0.75;
	}

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledCategoriesContainer = styled.div`
	display: flex;
	column-gap: 20px;
	margin-top: 40px;
`;

const StyledDescriptionContainer = styled.div`
	position: relative;
	width: 640px;
	margin-top: 40px;

	${Text} {
		text-align: center;
		font-size: 16px;
		line-height: 18px;
		font-weight: 400;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledDescriptionBackground = styled.img.attrs({ src: descBg })`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	user-select: none;
	pointer-events: none;
`;

const StyledButton = styled.button`
	margin-top: 60px;
	padding: 19px 33px;
	background-color: #2d70da;
	border-radius: 10px;

	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 19px;
	line-height: 22px;
	color: #ffffff;
	border: 0;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:disabled {
		background-color: rgba(255, 255, 255, 0.05);
		color: rgba(255, 255, 255, 0.25);
		cursor: default;
	}

	&:focus-visible {
		outline: none;
	}
`;

export {
	StyledButton,
	StyledCategoriesContainer,
	StyledContainer,
	StyledDescriptionBackground,
	StyledDescriptionContainer,
	StyledHeadingContainer,
};
